import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";

const styles = theme => ({});
const Spacer = ({ theme, w, h, right, left }) => (
  <div
    style={{
      width: w ? theme.spacing.unit * w : undefined,
      height: h ? theme.spacing.unit * h : undefined,
      marginLeft: right ? "auto" : undefined,
      marginRight: left ? "auto" : undefined
    }}
  />
);

Spacer.propTypes = {
  theme: PropTypes.object.isRequired,
  w: PropTypes.number,
  h: PropTypes.number,
  right: PropTypes.bool,
  left: PropTypes.bool
};

export default withStyles(styles, { withTheme: true })(Spacer);



// WEBPACK FOOTER //
// ./src/Components/New/Spacer.jsx